const VERSION = "25.5.1";
const URL = 'https://github.com/prezly/javascript-sdk';
export const DEFAULT_USER_AGENT = `prezly-javascript-sdk/${VERSION} (+${URL})`;